import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

export const construirContenidoPedido = (values) => {
  const { empresa = {}, venta = {}, insumos = [], origenLabel } = values || {};

  const fecha = moment().format("DD/MM/YYYY HH:mm");
  const folio = venta?.serieNumero || "—";

  const nombreCliente = venta?.clienteOnline
    ? `${venta.clienteOnline.nombre || ""} ${venta.clienteOnline.apellidoPaterno || ""} ${venta.clienteOnline.apellidoMaterno || ""}`.trim()
    : "";

  const totalPiezas = (insumos || []).reduce(
    (acc, ins) => acc + (Number(ins.cantidad) || 0),
    0,
  );

  const layoutPunteado = {
    hLineWidth: () => 1,
    vLineWidth: () => 1,
    hLineColor: () => "#adaaaa",
    vLineColor: () => "#adaaaa",
    hLineStyle: (i, node) =>
      i === 0 || i === node.table.body.length
        ? null
        : { dash: { length: 2, space: 1 } },
    vLineStyle: (i, node) =>
      i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } },
  };

  const terceraColumna = {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: "N° Empaquetado:", style: "subheader", alignment: "center" }],
        [{ text: folio, style: "textoChico", alignment: "center" }],
        [{ text: "Origen:", style: "subheader", alignment: "center" }],
        [{ text: origenLabel || "—", style: "textoChico", alignment: "center" }],
        [{ text: "Fecha:", style: "subheader", alignment: "center" }],
        [{ text: fecha, style: "textoChico", alignment: "center" }],
      ],
    },
    layout: "noBorders",
  };

  const headerTabla = [
    { text: "#", style: "thHeader", alignment: "center" },
    { text: "Cant.", style: "thHeader", alignment: "right" },
    { text: "Clave", style: "thHeader" },
    { text: "Descripción", style: "thHeader" },
    { text: "Listo", style: "thHeader", alignment: "center" },
  ];

  const filas = (insumos || []).map((ins, i) => [
    { text: String(i + 1), style: "tdCell", alignment: "center" },
    { text: String(ins.cantidad ?? ""), style: "tdCell", alignment: "right" },
    { text: ins.clave || "", style: "tdCell" },
    { text: ins.descripcion || ins.leyenda || "", style: "tdCell" },
    {
      text: ins.empaquetado ? "[X]" : "[  ]",
      style: "tdCell",
      alignment: "center",
      bold: !!ins.empaquetado,
    },
  ]);

  if (filas.length === 0) {
    filas.push([
      {
        text: "Este paquete no tiene insumos",
        colSpan: 5,
        alignment: "center",
        italics: true,
        style: "tdCell",
      },
      {},
      {},
      {},
      {},
    ]);
  }

  return [
    {
      style: "tableExample",
      table: {
        widths: ["18%", "52%", "30%"],
        layout: { defaultBorder: false },
        body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
      },
      layout: "noBorders",
    },
    {
      text: `Lista de empaquetado   N° ${folio}`,
      style: "tableHeaderIzquierda",
      margin: [0, 6, 0, 10],
    },
    {
      style: "tableExample",
      table: {
        widths: ["60%", "40%"],
        layout: { defaultBorder: false },
        body: [
          [
            {
              table: {
                widths: ["35%", "65%"],
                layout: { defaultBorder: false },
                body: [
                  [
                    { text: "Nombre del cliente :", style: "subheader" },
                    { text: nombreCliente || "—", style: "textoChico" },
                  ],
                  [
                    { text: "Origen :", style: "subheader" },
                    { text: origenLabel || "—", style: "textoChico" },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              table: {
                widths: ["55%", "45%"],
                layout: { defaultBorder: false },
                body: [
                  [
                    { text: "Total de piezas :", style: "subheader" },
                    { text: String(totalPiezas), style: "textoChico" },
                  ],
                  [
                    { text: "Artículos distintos :", style: "subheader" },
                    { text: String((insumos || []).length), style: "textoChico" },
                  ],
                ],
              },
              layout: "noBorders",
            },
          ],
        ],
      },
      layout: layoutPunteado,
    },
    {
      style: "tableExample",
      table: {
        headerRows: 1,
        widths: [22, 40, 80, "*", 45],
        body: [headerTabla, ...filas],
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => "#999999",
        vLineColor: () => "#999999",
        fillColor: (rowIndex) =>
          rowIndex === 0
            ? "#e8e8e8"
            : rowIndex % 2 === 0
              ? "#fafafa"
              : null,
        paddingTop: () => 4,
        paddingBottom: () => 4,
        paddingLeft: () => 5,
        paddingRight: () => 5,
      },
    },
  ];
};

export const stylesListaEmpaquetado = {
  header: { fontSize: 9, bold: true },
  subheader: { fontSize: 8, bold: true },
  textoChico: { fontSize: 8 },
  tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  tableExample: { margin: [0, 5, 0, 5] },
  thHeader: { bold: true, fontSize: 9 },
  tdCell: { fontSize: 9 },
};

const listaEmpaquetadoPdf = (values) => {
  const { empresa = {}, venta = {} } = values || {};
  const folio = venta?.serieNumero || "—";

  return {
    pageSize: "LETTER",
    pageMargins: [30, 35, 30, 40],
    info: {
      title: `Empaquetado - ${folio}`,
      author: empresa?.nombre || "ERP",
    },
    content: construirContenidoPedido(values),
    images: {
      logo: empresa?.logo?.base64Completa,
    },
    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: `Empaquetado · ${folio}`,
          alignment: "left",
          fontSize: 8,
          color: "#888",
          margin: [30, 0, 0, 0],
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: "right",
          fontSize: 8,
          color: "#888",
          margin: [0, 0, 30, 0],
        },
      ],
    }),
    defaultStyle: { fontSize: 9 },
    styles: stylesListaEmpaquetado,
  };
};

export default listaEmpaquetadoPdf;
